import React from 'react';
import PaymentList, { PaymentListTypeAccount, PaymentListTypePolicy } from './PaymentList';

const PaymentLists = ({ policies, accountGroups }) => {
	return (
		<React.Fragment>
			{accountGroups.length > 0 && (
				<PaymentList paymentListType={PaymentListTypeAccount} subjects={accountGroups} />
			)}

			{policies.length > 0 && (
				<PaymentList paymentListType={PaymentListTypePolicy} subjects={policies} />
			)}
		</React.Fragment>
	);
};

export default PaymentLists;
